// auth
export const oauthToken = '/oauth/token'
export const login = '/login'


// easyMS organizations
export const easymsOrganizations = '/api/organizations'

// easyMS categories
export const easymsCategories = organizationId => `/api/calendar/${organizationId}/categories`

// easyMS rates
export const easymsRates = organizationId => `/api/calendar/${organizationId}/rates`

// booking.com urls
export const bookingOrganizations = `/channel/booking/bookingOrganizations`
export const bookingCategories = `/channel/booking/bookingCategories`
export const bookingCategoriesFind = `/channel/booking/bookingCategories/search/findAllByOrganizationId`
export const bookingRates = `/channel/booking/bookingRates`
export const bookingRatesFind = `/channel/booking/bookingRates/search/findAllByOrganizationId`
export const reloadRatesFromBooking = `/channel/booking/bookingRates/reloadRatesFromBooking`
export const reloadCategoriesFromBooking = `/channel/booking/bookingCategories/reloadCategoriesFromBooking`
export const bookingCategorySelf = id => `/channel/booking/bookingCategories/${id}`
export const bookingOrganizationSelf = id => `/channel/booking/bookingOrganizations/${id}`
export const bookingRateSelf = id => `/channel/booking/bookingRates/${id}`
export const bookingPushYearPrices = '/channel/booking/pushYearPrices'
export const bookingPushYearRestrictions = '/channel/booking/pushYearRestrictions'
export const bookingInventoryAvailability = '/channel/booking/inventoryAvailability'
export const bookingInventoryOrder = '/channel/booking/inventoryOrder'
export const bookingOtelmsInventory = '/channel/booking/otelmsInventory'
export const bookingLoadBasedOnReservationSummary = '/channel/booking/loadBasedOnReservationSummary'

// hotels24.ua urls
export const h24Organizations = `/channel/hotels24/hotels24Organizations`
export const h24Categories = `/channel/hotels24/hotels24Categories`
export const h24CategoriesFind = `/channel/hotels24/hotels24Categories/search/findAllByOrganizationId`
export const h24Rates = `/channel/hotels24/hotels24Rates`
export const h24RatesFind = `/channel/hotels24/hotels24Rates/search/findAllByOrganizationId`
export const reloadRatesFromH24 = `/channel/hotels24/hotels24Rates/reloadRatesFromHotels24`
export const reloadCategoriesFromH24 = `/channel/hotels24/hotels24Categories/reloadCategoriesFromHotels24`
export const h24CategorySelf = id => `/channel/hotels24/hotels24Categories/${id}`
export const h24OrganizationSelf = id => `/channel/hotels24/hotels24Organizations/${id}`
export const h24RateSelf = id => `/channel/hotels24/hotels24Rates/${id}`
export const h24PushYearPrices = '/channel/hotels24/pushYearPrices'
export const h24PushYearRestrictions = '/channel/hotels24/pushYearRestrictions'
export const h24InventoryAvailability = '/channel/hotels24/inventoryAvailability'

// hostelworld.com urls
export const hwCategories = '/channel/hw/hwCategories'
export const hwOrganizations = '/channel/hw/hwOrganizations'
export const hwCategoriesFind = `/channel/hw/hwCategories/search/findAllByOrganizationId`
export const hwRates = '/channel/hw/hwRates'
export const hwRatesFind = `/channel/hw/hwRates/search/findAllByOrganizationId`
export const reloadRatesFromHw = '/channel/hw/hwRates/reloadRatesFromHw'
export const reloadCategoriesFromHw = '/channel/hw/hwCategories/reloadCategoriesFromHw'
export const hwCategorySelf = id => `/channel/hw/hwCategories/${id}`
export const hwOrganizationSelf = id => `/channel/hw/hwOrganizations/${id}`
export const hwRateSelf = id => `/channel/hw/hwRates/${id}`
export const hwPushYearPrices = '/channel/hw/pushYearPrices'
export const hwCheckAndPullOrders = '/channel/hw/checkAndPullOrders'
export const hwInventoryAvailability = '/channel/hw/inventory/availability'

// dobovo.com urls
export const dobovoOrganizations = `/channel/dobovo/dobovoOrganizations`
export const dobovoApartments = `/channel/dobovo/dobovoMappings`
export const dobovoApartmentsFind = `/channel/dobovo/dobovoMappings/search/findAllByDobovoOrganizationId`
export const reloadApartmentsFromDobovo = `/channel/dobovo/dobovoMappings/reloadApartmentsFromDobovo`
export const dobovoApartmentSelf = id => `/channel/dobovo/dobovoMappings/${id}`
export const dobovoOrganizationSelf = id => `/channel/dobovo/dobovoOrganizations/${id}`
export const dobovoPushYearPrices = '/channel/dobovo/pushYearPrices'
export const dobovoPushYearRestrictions = '/channel/dobovo/pushYearRestrictions'
export const dobovoPushYearAvailability = '/channel/dobovo/pushYearAvailability'
export const dobovoSynchronizeProperty = '/channel/dobovo/synchronizeProperty'

// expedia.com urls
export const expediaOrganizations = `/channel/expedia/expediaOrganizations`
export const expediaCategories = `/channel/expedia/expediaCategories`
export const expediaCategoriesFind = `/channel/expedia/expediaCategories/search/findAllByOrganizationId`
export const expediaRates = `/channel/expedia/expediaRates`
export const expediaRatesFind = `/channel/expedia/expediaRates/search/findAllByOrganizationId`
export const expediaRateSelf = id => `/channel/expedia/expediaRates/${id}`
export const reloadRatesFromExpedia = '/channel/expedia/expediaRates/reloadRatesFromExpedia'
export const reloadCategoriesFromExpedia = `/channel/expedia/expediaCategories/reloadCategoriesFromExpedia`
export const expediaCategorySelf = id => `/channel/expedia/expediaCategories/${id}`
export const expediaOrganizationSelf = id => `/channel/expedia/expediaOrganizations/${id}`
export const expediaPushYearPrices = '/channel/expedia/pushYearPrices'
export const expediaPushYearRestrictions = '/channel/expedia/pushYearRestrictions'
export const expediaPushYearAvailability = '/channel/expedia/pushYearAvailability'
export const expediaInventoryAvailability = '/channel/expedia/inventory/availability'
export const expediaInventoryOrder = '/channel/expedia/inventory/order'

//omnitec urls
export const omnitecOrganizationsFind = '/api/integration/omnitec/organizations'
export const omnitecOrganizations = '/api/integration/omnitec/organizations'
export const omnitecOrganizationUpdate = id => `/api/integration/omnitec/organizations/${id}`
export const omnitecOrganizationDelete = id => `/api/integration/omnitec/organizations/${id}`
export const omnitecLocksFind = '/api/integration/omnitec/rooms'
export const createPrivateRoom = '/api/integration/omnitec/rooms/private'
export const createCommonArea = '/api/integration/omnitec/rooms/commonArea'

export const omnitecPrivateRoomsFind = '/api/integration/omnitec/rooms/private'
export const omnitecCommonAreaFind = '/api/integration/omnitec/rooms/commonArea'

export const omnitecDeletePrivateRoom = id => `/api/integration/omnitec/rooms/private/${id}`
export const omnitecDeleteCommonArea  = id => `/api/integration/omnitec/rooms/commonArea/${id}`

export const omnitecEncodersFetch = id => `/api/integration/omnitec/encoders?organizationId=${id}`
export const omnitecEncodersCreate = '/api/integration/omnitec/encoders'
export const omnitecEncoderDelete = id => `/api/integration/omnitec/encoders/${id}`


// WEBPACK FOOTER //
// ./src/api/urls.js